import { persistSessionId } from "../PersistActions";

export const appStart = () => [
  persistSessionId(),
  // add other actions if needed
];
